module.exports = __webpack_public_path__ + "img/baseline-check-24px.235701a7.svg";